import { Typography } from '@altibox/design-system-component-lib';
import { styled } from 'styled-components';

import { BulletListElement } from 'src/components/bullet-points';
import { Image } from 'src/components/image';
import { breakpointTablet } from 'src/styles/breakpoints';
import { spacing1, spacing2 } from 'src/styles/spacing';

export const StyledProductContainer = styled.div`
  display: flex;
  align-items: flex-start;

  @media (min-width: ${breakpointTablet}) {
    padding: ${spacing2} 0 0;
  }
`;

export const StyledImage = styled(Image)`
  display: none;

  @media (min-width: ${breakpointTablet}) {
    max-width: 70px;
    margin-right: ${spacing2};
    display: block;
  }
`;

export const StyledProductInformation = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
`;

export const StyledProductTitleAndPrice = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${spacing2};
`;

export const StyledMonthlyPrice = styled(Typography)`
  margin-left: ${spacing2};
  flex-shrink: 0;
`;

export const StyledBulletListElement = styled(BulletListElement)`
  margin-bottom: ${spacing1};

  &:last-child {
    margin-bottom: 0;
  }
`;
